import React from 'react';
import AudioHelper from "../../../helpers/AudioHelper";

function findAudioEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'AUDIO'
            );
        },
        callback
    );
}

const Audio = (props) => {
    const audio = props.contentState.getEntity(props.entityKey).getData();

    return <figure className="audio-atomic-block">
        <audio src={AudioHelper.getUrl(audio)} controls/>
        <figcaption>{props.children}</figcaption>
    </figure>;
};



export default {
    strategy: findAudioEntities,
    component: Audio,
};

